module.exports = __webpack_public_path__ + "static/media/zolaicons.d9606762.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/build/assets/fonts/zolaicons.svg?34023347
// module id = 453
// module chunks = 46